import React from "react";
import {Container, Typography, Box, Avatar, Paper, Stack, Divider} from "@mui/material";
import SectionTitle from "../components/layouts/others/title-section.layout";
// @ts-ignore
import photoJpg from "../assets/images/others/jpg.png"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMegaport} from "@fortawesome/free-brands-svg-icons";
import { faEnvelopeOpenText } from "@fortawesome/free-solid-svg-icons";

const VLDCampaign2026: React.FC = () => (
    <Container sx={{ mb: 5 }}>
        <SectionTitle title="ESPACE CAMPAGNE VLD 2026" />

        <Box display="flex" justifyContent="center" alignItems="center" mt={4} mb={2}>
            <Box textAlign="center">
                <Avatar
                    src={photoJpg}
                    alt="Photo de Jean-Philippe GUIBERT"
                    sx={{
                        width: 192,
                        height: 192,
                        mx: "auto",
                        boxShadow: "0px 4px 18px rgba(0,0,0,0.18)",
                        border: "6px solid #1976d2",
                    }}
                />
                <Typography variant="subtitle1" align="center" fontWeight={700} mt={2}>
                    Jean-Philippe Guibert
                </Typography>
                <Typography variant="subtitle2" align="center" fontWeight={500} color="text.secondary">
                    Candidat à la mairie de&nbsp;Bois-le-Roi&nbsp;2026
                </Typography>
            </Box>
        </Box>

        <Paper elevation={3} sx={{ p: { xs: 3, sm: 4 }, mt: 2, mb: 4, borderRadius: 3, background: "linear-gradient(107deg,#fffde4 60%, #edf7fa 100%)" }}>
            <Stack spacing={3}>

                <Box display="flex" alignItems="center" gap={1}>
                    <FontAwesomeIcon icon={faMegaport} size="lg" color="#1976d2" />
                    <Typography variant="h5" fontWeight={700} color="primary">
                        Lancement de la campagne VLD 2026
                    </Typography>
                </Box>
                <Divider />
                <Typography variant="body1" fontSize="1.15rem">
                    C’est avec détermination et espoir que j’annonce ma candidature aux élections municipales de 2026 à Bois-le-Roi, à la tête de la liste <b>Vivre la Démocratie&nbsp;(VLD)</b>.
                </Typography>
                <Typography variant="body1" fontSize="1.1rem">
                    <b>VLD</b>
                    , c’est le projet d’une équipe diverse et engagée, pour redonner confiance, dynamisme et transparence à notre commune, et replacer l’humain au cœur des décisions publiques.
                </Typography>
                <Typography variant="body2" color="primary" fontWeight={600}>
                    Ensemble, préparons l’avenir de Bois-le-Roi dans la démocratie, l’écoute et la préservation de la qualité de vie.
                </Typography>
                <Divider />
                <Box textAlign="center">
                    <Typography variant="subtitle1" fontWeight={700} color="secondary" mb={2}>
                        <FontAwesomeIcon icon={faEnvelopeOpenText} style={{ marginRight: 8 }} />
                        Davantage d’informations et de propositions seront présentées très prochainement.
                    </Typography>
                </Box>
            </Stack>
        </Paper>
    </Container>

);

export default VLDCampaign2026;